

































































import { Subscription, Voucher, Form, FormStep, CommonField, Event, EventJson } from '@ssp/inscreva-sse-models';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { sessionStore } from '../store/session';
import DynamicInfoComponent from './DynamicInfoList.vue';

@Component({
  components: {
    DynamicInfoList: DynamicInfoComponent,
  },
})
export default class SubscriptionFormComponent extends Vue {
  @Prop({ required: true })
  private subscription!: Subscription;

  qrCodeForVoucher(voucher: Voucher) {
    return `http://chart.apis.google.com/chart?cht=qr&chs=80x80&chl=${voucher.code}`;
  }

  get event(): Event {
    return EventJson.fromJson(sessionStore.session.event);
  }

  get form(): Form {
    return (this.event.steps.find(({ type }) => type === 'form') as FormStep).form;
  }

  get infos() {
    return this.form.fields
      .filter((field) => !!this.subscription[field.id])
      .map((field) => ({
        ...field,
        value: this.subscription[field.id],
      }));
  }

  selectedOptions(info: CommonField & { value: Array<Record<string, any>> }) {
    return info.options.filter((option) => Object.keys(info.value).includes(option.name));
  }

  onBack() {
    return this.$emit('on-back');
  }
}
